import React, { Fragment } from 'react';
import { convertGameType, dateFormation, convertBettingHistory } from '../../common/cores';

const DetailItem = (props) => {
    console.log(props)
    const { type } = props;
    console.log(props.history);
    const history = convertBettingHistory(props.history, props.type);
    console.log(history);
    return (
            <div data-v-7c26ed95="" className="log-wrap column" style={{ marginBottom: "20px" }}>
                <div data-v-7c26ed95="" className="log column">
                    <div data-v-7c26ed95="" className="row" style={{ flexDirection: "row" }}>
                        <div data-v-7c26ed95="" className="margin-right-10 row" style={{ flexDirection: "row" }}>
                            <span data-v-7c26ed95="" className="margin-right-5 text" style={{ color: "rgb(232, 196, 20)" }}>
                                { history.gameType }
                            </span>
                            <span data-v-7c26ed95="" className="margin-right-5 text">
                                <img data-v-7c26ed95="" src={history.sportImg} className="sports-icon" style={{ width: "18px", height: "18px" }} alt="" />
                            </span>
                            <span data-v-7c26ed95="" className="text">{history.sportName}</span>
                        </div>
                        <div data-v-7c26ed95="" className="margin-right-10 row" style={{ flexDirection: "row" }}>
                            <span data-v-7c26ed95="" className="margin-right-5 text">
                                <div data-v-3285b224="" data-v-7c26ed95="" className="tournament-icon row"
                                    style={{ flexDirection: "row" }}>
                                    <img data-v-3285b224="" src={history.leagueImg} alt="" />
                                </div>
                            </span>
                            <span data-v-7c26ed95="" className="text-ellipsis text" style={{ display: "block" }}>
                                {history.leagueName}
                            </span>
                        </div>
                        <div data-v-7c26ed95="" className="spacer"></div>
                        <span data-v-7c26ed95="" className={`padding-horizontal-2 text ${history.winClass}`} style={{ flexShrink: "0" }}>
                            {history.wintype}
                        </span>
                    </div>
                    { ((type === "prematch" || type === "live" || type === "esport" || type === "betgame365") && props.history.odd_name !== "oneteam" ) && 
                        <div data-v-7c26ed95="" className="row" style={{ flexDirection: "row" }}>
                            <div data-v-7c26ed95="" className="margin-right-5 row" style={{ flexDirection: "row" }}>
                                <span data-v-7c26ed95="" className="text" style={{ opacity: "0.6" }}>{history.time}</span>
                            </div>
                            <div data-v-7c26ed95="" className="text-ellipsis row" style={{ flexDirection: "row" }}>
                                <div data-v-7c26ed95="" className="text-ellipsis row" style={{ flexDirection: "row" }}>
                                    <div data-v-cc68f3fe="" data-v-7c26ed95="" className="team-icon row" style={{ flexDirection: "row", flexShrink: "0" }}>
                                        <img data-v-cc68f3fe="" src="../images/home.f33c6e6.png" className="blank-home" style={{ width: "16px", height: "16px" }} alt="" />
                                    </div>
                                    <span data-v-7c26ed95="" className="text-ellipsis-block text">
                                        {history.homeTeam}
                                    </span>
                                </div>
                                <span data-v-7c26ed95="" className="margin-horizontal-10 text" style={{ opacity: "0.6" }}>vs</span>
                                <div data-v-7c26ed95="" className="text-ellipsis row" style={{ flexDirection: "row" }}>
                                    <div data-v-cc68f3fe="" data-v-7c26ed95="" className="team-icon row" style={{ flexDirection: "row", flexShrink: "0" }}>
                                        <img data-v-cc68f3fe="" src="../images/away.e0c4aae.png" className="" style={{ width: "16px", height: "16px" }} alt="" />
                                    </div>
                                    <span data-v-7c26ed95="" className="text-ellipsis-block text">
                                        {history.awayTeam}
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                    <div data-v-7c26ed95="" className="pick row" style={{ flexDirection: "row" }}>
                        <span data-v-7c26ed95="" className="margin-right-5 text" style={{ color: "#f6c33a" }}>{history.marketName}</span>
                        <span data-v-7c26ed95="" className="text">{history.marketDetail}</span>
                        <div data-v-7c26ed95="" className="spacer">{history.baseline}</div>
                        <span data-v-7c26ed95="" className="text" style={{ color: "#f6c33a" }}>{history.rate}</span>
                    </div>
                </div>
            </div>
    )
}

export default DetailItem;


// WEBPACK FOOTER //
// ./src/components/account/DetailItem.js